import { defineComponent as _defineComponent } from 'vue';
import Button from 'primevue/button';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SaveCancelButtons',
    emits: ['cancel', 'save'],
    setup(__props, { expose, emit }) {
        expose();
        const __returned__ = { emit, get Button() { return Button; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
